import Vue from 'vue'
import merge from 'lodash/merge'

export default {
  UPDATE_STYLE_SETTINGS: (state, payload) => Vue.set(state.settings[payload.gate], 'styling', merge({}, state.settings[payload.gate].styling, payload.data)),
  UPDATE_CONTENT_SETTINGS: (state, payload) => Vue.set(state.settings[payload.gate], 'content', merge({}, state.settings[payload.gate].content, payload.data)),
  UPDATE_CONFIGURATION_SETTINGS: (state, payload) => Vue.set(state.settings[payload.gate], 'configuration', merge({}, state.settings[payload.gate].configuration, payload.data)),
  UPDATE_TYPE: (state, payload) => Vue.set(state.configuration, 'type', payload),
  SET_ACTIVATION_STATUS: (state, payload) => Vue.set(state, 'activationStatus', payload),
  UPDATE_SITEGATE_SETTINGS: (state, payload) => Vue.set(state, 'settings', payload),
  CHANGE_INITIAL_LOAD_SITE_GATE: (state, payload) => Vue.set(state.settings.configuration, 'initialLoadGate', payload),
  SET_SITEGATE_SETTINGS_TIMESTAMP: (state, payload) => Vue.set(state.settings.configuration, 'timestamp', payload),
  SET_SITEGATE_INVALIDATION_TIMESTAMP: (state, payload) => Vue.set(state.settings[payload.gate].configuration, 'invalidationTimestamp', payload.timestamp),
  RESET_SITEGATE_INVALIDATION: (state, payload) => Vue.set(state.settings[payload].configuration, 'forcedInvalidation', false)
}
